<template>
  <div class="videoPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':2,'value':'待审核'},{'key':1,'value':'审核通过'},{'key':0,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>视频标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px"
                    v-model="title"></el-input>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">批量审核</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
         </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="视频标题" prop="title" align="center"/>
          <el-table-column label="发布者" prop="nickname" align="center"></el-table-column>
          <el-table-column label="视频说明" width="350" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.remark }}
                </template>
                <span
                    style="width:330px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{
                    scope.row.remark
                  }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="视频" prop="ossUrl" align="center" width="100">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-button @click="viewVideoBtn(scope.row)" size="small" type="text">播放</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag v-if="scope.row.examineStatus == '2'" type="warning"
                        size="small" effect="dark">待审核
                </el-tag>
                <el-tag v-else-if="scope.row.examineStatus == '1'" type="success" size="small" effect="dark">审核通过
                </el-tag>
                <el-tag v-else-if="scope.row.examineStatus == '0'" type="danger" size="small" effect="dark">审核未通过
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否轮播" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.isRotation) === 1 ? '是' : '否' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否置顶" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.isLike) === 1 ? '是' : '否' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="100" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.createDate }}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="权重" width="100" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.sortTime ? scope.row.sortTime : '' }}
                </template>
                {{ scope.row.sortTimeList && scope.row.sortTimeList.length ? scope.row.sortTimeList[0] : '' }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="240"
          >
            <template slot-scope="scope">
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examineStatus == '2'"
                         size="small" type="success">审核
              </el-button>
              <el-button @click="editBtn(scope.row)"
                         size="small" type="success">编辑
              </el-button>
              <el-button @click="delBtn(scope.row)"
                         size="small" type="danger">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="500px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="权重时间" prop="sort">
          <el-date-picker
              v-model="ruleForm.sort"
              type="datetime"
              size="small" style="width: 240px;"
              value-format="timestamp"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发布时间" prop="createDate">
          <el-date-picker
              v-model="ruleForm.createDate"
              type="datetime"
              size="small" style="width: 240px;"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否轮播" prop="isRotation">
          <el-select v-model="ruleForm.isRotation" size="small" style="width: 240px;" clearable
                     placeholder="请选择轮播状态">
            <el-option
                v-for="item in [{'key':1,'value':'是'},{'key':0,'value':'否'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶" prop="isLike">
          <el-select v-model="ruleForm.isLike" size="small" style="width: 240px;" clearable
                     placeholder="请选择置顶状态">
            <el-option
                v-for="item in [{'key':1,'value':'是'},{'key':0,'value':'否'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频标题">
          <el-input v-model="ruleForm.title" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="视频说明">
          <el-input v-model="ruleForm.remark" type="textarea" style="width: 300px" :rows="5" ></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

      <!--    审核的弹窗-->
      <a-modal
      :visible="auditDialogState"
      cancel-text="取消"
      ok-text="确认"
      title="审核"
      width="400px"
      @cancel="auditDialogState=false"
      @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px" placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'1','value':'审核通过'},{'key':'0','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="delDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="delCancel"
        @ok="delSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";

export default {
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      dialogTitle: '',
      pageNum: 1,
      pageSize: 20,
      examineStatus: null,
      title: null,
      tableData: [],
      totalElements: 0,//数据总数
      addDialogState: false,
      ruleForm: {
        id: null,
        // examineStatus: null,
        isRotation: null,
        isLike: null,
        createDate: null,
        sort: null,
        title:null,
        remark:null,
      },
      rules: {
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
        isRotation: [{required: true, message: "请选择轮播状态", trigger: "blur"}],
        isLike: [{required: true, message: "请选择置顶状态", trigger: "blur"}],
        createDate: [{required: true, message: "请选择创建时间", trigger: "blur"}],
      },
      delDialogState: false,
      delId: null,
      videoDialogState: false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      },
        multipleSelection:[],
        auditBatchList:[],
        simpleDelete:false,//是单个删除还是多个删除
        simpleAudit:false,
        auditDialogState:false,
        auditId:'',
        auditRuleForm:{
          examineStatus:null
        },
        auditRules:{
          examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
        },
    };
  },
  methods: {
    viewVideoBtn(row){
      this.playerOptions.poster = row.frontCoverUrl
      this.playerOptions.sources[0].src = row.ossUrl
      this.videoDialogState = true
    },
    videoDialogCancel(){
      this.player.pause()
      this.videoDialogState = false
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.title = null
      this.getList()
    },
    editBtn(row) {
      this.dialogTitle = '编辑'
      this.ruleForm.id = row.id
      this.ruleForm.isRotation = Number(row.isRotation)
      this.ruleForm.isLike =Number(row.isLike)
      this.ruleForm.createDate = row.createDate
      this.ruleForm.sort = Number(row.sort)*1000
      this.ruleForm.title = row.title
      this.ruleForm.remark = row.remark
      this.addDialogState = true
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },

    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.createDate) {
            this.ruleForm.createDate = moment(this.ruleForm.createDate).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.ruleForm.sort && this.ruleForm.sort.toString().length === 13) {
            this.ruleForm.sort = Number(this.ruleForm.sort) / 1000
          }
          this.postAxios("/video/update", this.ruleForm).then(res => {
            if (res.success) {
              this.$message.success("操作成功!")
              this.addDialogState = false
              this.getList()
            }
          });
        }
      });
    },

    getList() {
      this.postAxios("/video/list", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title: this.title,
        examineStatus: this.examineStatus === '' ? null : this.examineStatus
      }).then(res => {
        if (res.success) {
          this.tableData = res.content;
          this.tableData.forEach((item) => {
            if (item.sort) {
              item.sortTime = moment(Number(item.sort) * 1000).format('YYYY-MM-DD HH:mm:ss')
              item.sortTimeList = item.sortTime.split(' ')
            }
            item.create_date_list = item.createDate.split(' ')
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    delBtn(row) {
      this.simpleDelete = true
      this.delId = row.id
      this.delDialogState = true
    },
    delCancel() {
      this.delDialogState = false
    },
    delSubmit() {
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/video/batchDeleteByIds", [
          this.delId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.delId = ''
            this.delDialogState = false
            this.getList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/video/batchDeleteByIds", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.multipleSelection=[]
            this.delDialogState = false
            this.getList()
          }
        })
      }


    },
    //多选操作过滤选中的id，批量删除id是所有，批量审核id是待审核状态的
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      if (this.multipleSelection&&this.multipleSelection.length){
        this.multipleSelection.forEach((item)=>{
          if (item.examineStatus === '2'){
            this.auditBatchList.push(item.id)
          }
        })
      }
    },
    // 批量删除按钮，打开批量删除弹窗
    batchDeleteBtn(){
      this.simpleDelete = false
      this.delDialogState = true
    },
    // 批量审核按钮，打开批量审核弹窗
    auditBatchBtn(){
      this.simpleAudit = false
      this.auditRuleForm.examineStatus = '1'
      this.auditDialogState = true
    },

    auditBtn(row){
      this.simpleAudit = true
      this.auditId = row.id
      this.auditRuleForm.examineStatus = '1'
      this.auditDialogState = true
    },

    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit){
            this.postAxios("/video/batchExamineByIds", {
              examineStatus:this.auditRuleForm.examineStatus,
              idList:[this.auditId]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditId = ''
                this.auditRuleForm.examineStatus=''
                this.auditDialogState = false
                this.getList()
              }
            })
          }else{
            this.postAxios("/video/batchExamineByIds", {
              examineStatus:this.auditRuleForm.examineStatus,
              idList:this.auditBatchList
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditRuleForm.examineStatus=''
                this.auditDialogState = false
                this.getList()
              }
            })
          }
        }
      });
    },
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.cover-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cover-uploader .el-upload:hover {
  border-color: #409EFF;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  width: 300px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover {
  width: 300px;
  height: 150px;
  display: block;
}
</style>
